var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFashoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 294,
    viewBox: "0 0 409 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_2261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.077 0.1698H0.12793V192.27H300.077V0.1698Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 24.2639H8.70508V180.905H291.5V24.2639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.949 0H0V12.7428H299.949V0Z",
    fill: "#6C59E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46942 8.87719C10.7739 8.87719 11.8314 7.81969 11.8314 6.5152C11.8314 5.2107 10.7739 4.1532 9.46942 4.1532C8.16493 4.1532 7.10742 5.2107 7.10742 6.5152C7.10742 7.81969 8.16493 8.87719 9.46942 8.87719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4343 8.87719C19.7388 8.87719 20.7963 7.81969 20.7963 6.5152C20.7963 5.2107 19.7388 4.1532 18.4343 4.1532C17.1298 4.1532 16.0723 5.2107 16.0723 6.5152C16.0723 7.81969 17.1298 8.87719 18.4343 8.87719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3991 8.87719C28.7036 8.87719 29.7611 7.81969 29.7611 6.5152C29.7611 5.2107 28.7036 4.1532 27.3991 4.1532C26.0946 4.1532 25.0371 5.2107 25.0371 6.5152C25.0371 7.81969 26.0946 8.87719 27.3991 8.87719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8094 37.1481H43.499V97.155H98.8094V37.1481Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.757 37.1481H122.446V97.155H177.757V37.1481Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.704 37.1481H201.394V97.155H256.704V37.1481Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8094 108.016H43.499V168.023H98.8094V108.016Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.757 108.016H122.446V168.023H177.757V108.016Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.704 108.016H201.394V168.023H256.704V108.016Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.815 123.438L145.921 119.443L147.096 139.42C147.096 139.42 149.211 145.53 148.506 147.88C148.506 147.88 148.976 151.876 147.801 152.111C146.626 152.346 143.334 152.816 143.102 152.581C142.869 152.345 142.867 151.641 142.867 151.641C142.867 151.641 140.517 153.286 140.282 155.166C140.282 155.166 130.411 158.221 130.176 155.401C129.941 152.58 135.111 150.23 135.111 150.23L139.106 144.12L135.815 123.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.203 123.438L167.307 119.443L168.483 139.42C168.483 139.42 170.598 145.53 169.893 147.88C169.893 147.88 170.363 151.876 169.187 152.111C168.012 152.346 164.721 152.816 164.489 152.581C164.256 152.345 164.254 151.641 164.254 151.641C164.254 151.641 161.903 153.286 161.668 155.166C161.668 155.166 151.797 158.221 151.562 155.401C151.328 152.58 156.498 150.23 156.498 150.23L160.493 144.12L157.203 123.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.191 46.2955C158.191 46.2955 156.039 52.3082 158.532 55.0196L156.453 62.1624C156.453 62.1624 163.839 84.3178 161.729 87.4126C161.729 87.4126 153.851 91.3512 138.095 86.0057L144.495 61.1775L143.581 50.6976L144.847 45.774L147.66 45.4949C147.66 45.4949 145.972 51.8249 149.067 52.8098C152.162 53.7947 155.18 45.6531 155.18 45.6531L158.191 46.2955Z",
    fill: "#F0B518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8154 85.1086L61.531 86.2196L74.4915 69.186L78.5647 89.1817L81.2802 88.6881C83.0221 71.4489 84.4438 53.8653 82.6997 45.5488L72.6399 45.1166L68.0731 59.6835L65.8512 69.5581L58.8154 85.1086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.628 45.4125C223.628 45.4125 219.922 50.5645 220.103 52.6436C220.284 54.7228 222.634 88.6189 222.634 88.6189L228.148 88.8901L226.52 64.4848L227.875 57.8864L231.22 88.6189L237.999 88.7998L231.943 48.938L230.768 45.4129L223.628 45.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.574 128.413C243.59 127.232 241.898 126.594 240.274 126.249C240.32 126.101 235.334 125.071 235.249 125.283L233.369 123.786L227.593 126.785L224.347 124.575L222.839 125.11C222.9 124.844 218.158 125.666 218.158 125.666C217.252 125.698 216.095 125.755 214.8 125.854C210.264 126.203 209.915 137.951 209.915 137.951C212.002 137.097 214.227 136.631 216.481 136.576L217.707 150.626C224.012 150.085 230.625 150.714 237.479 152.254L240.694 141.21L248.179 138.299C248.179 138.299 246.9 131.204 244.574 128.413Z",
    fill: "#0153AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9472 121.723C83.1363 120.75 81.743 120.224 80.4045 119.94C80.4445 119.818 76.3341 118.969 76.2639 119.144L74.7147 117.91L69.9558 120.381L67.2811 118.561L66.0389 119.002C66.0896 118.783 62.1821 119.459 62.1821 119.459C61.4378 119.486 60.4822 119.533 59.4154 119.615C55.6781 119.903 55.3906 129.581 55.3906 129.581C57.1101 128.878 58.9436 128.494 60.8008 128.448L61.8109 156.788C67.0062 156.342 72.455 156.861 78.1011 158.129L80.7492 132.267L86.9168 129.869C86.9168 129.869 85.8636 124.023 83.9472 121.723Z",
    fill: "#00954A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.67 129.266H375.188V115.076C375.188 111.56 373.791 108.187 371.305 105.701C368.818 103.214 365.446 101.817 361.929 101.817C358.413 101.817 355.04 103.214 352.553 105.701C350.067 108.187 348.67 111.56 348.67 115.076V129.266Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.833 287.14H331.13L328.416 265.139H336.834L336.833 287.14Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.288 285.278H327.055C325.156 285.278 323.336 286.033 321.993 287.375C320.651 288.717 319.897 290.538 319.896 292.436V292.669H338.288V285.278Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.014 279.529L400.047 282.333L386.868 264.509L394.199 260.371L405.014 279.529Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.366 277.192L395.584 282.713C393.931 283.646 392.716 285.198 392.207 287.027C391.698 288.856 391.937 290.812 392.87 292.465L392.985 292.668L409 283.627L405.366 277.192Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.562 188.199L369.002 190.399C369.002 190.399 370.322 191.72 369.662 192.38C369.002 193.04 369.222 196.121 369.222 196.121C369.591 201.739 376.932 233.31 378.245 239.476C378.245 239.476 388.368 246.078 396.291 259.062C404.213 272.047 404.433 275.348 404.433 275.348L395.631 279.09L373.626 252.461C373.626 252.461 367.464 248.719 365.263 245.418C363.062 242.118 349.415 208.005 349.415 208.005L341.711 243.658C341.711 243.658 342.151 256.642 340.17 265.005C338.952 270.282 338.216 275.66 337.97 281.07L327.626 279.97C327.626 279.97 328.286 248.719 329.386 245.418C329.386 245.418 324.765 207.345 334.008 192.16L341.457 172.3L348.753 169.492L368.562 188.199Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.067 105.286C348.181 105.523 348.183 126.178 362.067 126.413C375.952 126.176 375.95 105.521 362.067 105.286Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38 115.301H353.74L354.383 113.695L354.061 115.301H366.969L366.55 111.939L369.688 115.301H372.817V113.48C372.818 112.072 372.542 110.678 372.005 109.377C371.467 108.077 370.678 106.894 369.684 105.899C368.689 104.903 367.508 104.112 366.208 103.573C364.908 103.033 363.514 102.755 362.107 102.754C360.699 102.753 359.306 103.029 358.005 103.567C356.704 104.105 355.522 104.893 354.526 105.888C353.53 106.882 352.74 108.063 352.2 109.363C351.66 110.663 351.382 112.057 351.381 113.464V113.48L351.38 115.301Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.747 132.581L373.987 132.794L368.443 189.049C368.443 189.049 337.756 187.429 337.737 178.063L340.612 169.739L347.747 132.581Z",
    fill: "#6C59E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.115 194.487C374.712 193.993 374.422 193.416 374.265 192.798C374.109 192.18 374.09 191.535 374.209 190.909C374.329 190.282 374.585 189.69 374.958 189.173C375.332 188.656 375.814 188.227 376.371 187.917L375.231 178.013L381.08 175.852L382.494 189.861C382.951 190.831 383.036 191.935 382.734 192.964C382.432 193.993 381.763 194.875 380.855 195.445C379.947 196.014 378.861 196.231 377.803 196.055C376.746 195.878 375.789 195.32 375.115 194.487Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.537 137.64L373.989 132.814C373.989 132.814 376.352 132.29 379.144 135.547C381.935 138.803 383.564 179.511 383.564 179.511L373.328 181.838L367.28 152.993L370.537 137.64Z",
    fill: "#6C59E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.701 181.785L313.462 217.951L336.875 230.324L379.513 222.71L380.56 185.116L353.531 175.599L312.701 181.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.814 230.715L313.093 218.179L312.32 181.465L353.567 175.215L353.655 175.246L380.942 184.854L379.879 223.025L336.814 230.715ZM313.832 217.724L336.936 229.934L379.148 222.396L380.179 185.379L353.495 175.982L313.082 182.106L313.832 217.724Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.352 191.591L336.261 191.555L312.562 182.133L312.838 181.438L336.445 190.824L380.509 184.746L380.611 185.487L336.352 191.591Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.773 191.203L336.025 191.212L336.501 230.329L337.249 230.32L336.773 191.203Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.358 189.719L324.815 186.256L365.94 179.703L374.483 183.166L333.358 189.719Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.848 192.277L312.553 192.964L322.461 197.229L322.756 196.543L312.848 192.277Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.336 204.615L317.04 205.302L326.948 209.567L327.244 208.881L317.336 204.615Z",
    fill: "#6C59E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.436 232.031L183.197 268.197L206.61 280.57L249.248 272.956L250.295 235.362L223.265 225.844L182.436 232.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.548 280.96L182.827 268.425L182.054 231.71L223.301 225.461L223.388 225.492L250.675 235.1L249.612 273.27L206.548 280.96ZM183.565 267.969L206.67 280.179L248.882 272.641L249.912 235.624L223.228 226.228L182.815 232.351L183.565 267.969Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.087 241.837L205.995 241.8L182.297 232.378L182.573 231.683L206.18 241.069L250.243 234.992L250.345 235.732L206.087 241.837Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.508 241.448L205.76 241.457L206.236 280.574L206.983 280.565L206.508 241.448Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.022 239.113L194.549 236.501L235.673 229.948L242.146 232.56L201.022 239.113Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.583 242.522L182.287 243.209L192.195 247.475L192.491 246.788L182.583 242.522Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.069 254.86L186.773 255.547L196.681 259.813L196.977 259.126L187.069 254.86Z",
    fill: "#6C59E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.109 236.989L223.993 278.973L251.172 293.335L300.668 284.497L301.883 240.856L270.506 229.808L223.109 236.989Z",
    fill: "#6C59E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.102 293.788L223.565 279.237L222.668 236.617L270.549 229.363L270.651 229.398L302.326 240.552L301.092 284.862L251.102 293.788ZM224.422 278.708L251.243 292.881L300.244 284.131L301.441 241.16L270.465 230.253L223.552 237.361L224.422 278.708Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.566 248.373L250.46 248.33L222.949 237.393L223.27 236.586L250.674 247.481L301.824 240.426L301.942 241.286L250.566 248.373Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.054 247.922L250.186 247.932L250.738 293.34L251.606 293.33L251.054 247.922Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.126 245.231L237.172 242.18L284.911 234.573L292.866 237.624L245.126 245.231Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.281 249.168L222.938 249.965L234.439 254.917L234.782 254.12L223.281 249.168Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.49 263.491L228.146 264.288L239.648 269.24L239.991 268.443L228.49 263.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.976 187.765C326.553 187.494 327.064 187.1 327.472 186.61C327.88 186.121 328.177 185.547 328.34 184.931C328.502 184.314 328.528 183.67 328.415 183.042C328.302 182.415 328.052 181.819 327.684 181.299L332.998 172.864L328.66 168.385L321.323 180.401C320.49 181.078 319.933 182.037 319.759 183.096C319.585 184.155 319.806 185.242 320.379 186.149C320.952 187.057 321.839 187.723 322.87 188.021C323.902 188.319 325.007 188.228 325.976 187.766V187.765Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.78 134.798L347.973 132.29C347.973 132.29 345.035 132.949 341.91 138.959C338.786 144.968 326.186 171.838 326.186 171.838L331.365 177.095L345.183 156.015L351.78 134.798Z",
    fill: "#6C59E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_2261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 293.789,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashoin);
export default __webpack_public_path__ + "static/media/fashoin.662ae4af3d4675e93aeec14d23b51f74.svg";
export { ForwardRef as ReactComponent };